var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"frameUp"}},[_c('div',{staticClass:"fondo"}),_c('div',{staticClass:"contenido show"},[(_vm.servicio === 'empresa')?_c('div',[_c('Empresa')],1):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }